import {mixedMeasure} from '../default/';

function _axis() {
  let that = this;
  let scale = this.__execs__.scale;
  let axisToggles = this.axis();
  let nested = this.isNested();
  let facet = this.facet();
  let orient = this.orient();
  let measures = this.measures();
  let grid = this.grid();
  let innerSize = this.innerSize();
  let aggregated = this.aggregated();
  let mixed = this.isMixed();
  let fieldObj = this.__execs__.field;

  let _axisScaleX = function (axisToggle) {
    let targetField = fieldObj.region || fieldObj.x;
    axisToggle.field = targetField.field;
    let curAxis = that.axisDefault(nested? scale.region : scale.x, axisToggle);
    if (axisToggle.orient === 'bottom') curAxis.y(scale.y.range()[0]);
    
    if (targetField.interval && targetField.format) { //FIXME: region 있으면 region으로
      curAxis.tickFormat(targetField.format);
    }
    return curAxis;
  }

  let _axisScaleY = function (axisToggle) {
    let field;
    if (aggregated && fieldObj.y.field === mixedMeasure.field) field = '';
    else if (mixed) field = measures.map(d => d.field).join('-');
    else field = fieldObj.y.field;
    axisToggle.field = field;
    let curAxis = that.axisDefault(scale.y, axisToggle);
    curAxis.grid(grid).gridSize(axisToggle.orient === 'bottom' || axisToggle.orient === 'top' ? innerSize.height : innerSize.width);
    if (axisToggle.orient === 'bottom') curAxis.y( (nested ? scale.region : scale.x).range()[1]);
    return curAxis;
  }

  let xAt = this.axisX();
  let yAt = this.axisY();
  if (this.isFacet()) {
    //horizontal 일 경우 top d1
    //vertical 일 경우 right d1
    let field ;
    if (mixed) field = measures.map(d => d.field).join('-');
    else field = fieldObj.x.field; 
    if (facet.orient === 'horizontal' && xAt) {
      xAt.field = field;
      xAt.orient = 'top';
      xAt.showDomain = false;
      this.axisDefault(scale.region, xAt);
    } else if (facet.orient === 'vertical' && yAt) {
      yAt.field = field;
      yAt.orient = 'right';
      yAt.showDomain = false;
      this.axisDefault(scale.region, yAt).x(innerSize.width);
    }
  } else {
    if (xAt) {
      if (orient === 'vertical') { 
        _axisScaleX(xAt);
      } else {
        _axisScaleY(xAt);
      }
    } 
    if (yAt) {
      if (orient === 'horizontal') { 
        _axisScaleX(yAt);
      } else {
        _axisScaleY(yAt);
      }
    }
  }

  this.renderAxis();
}

export default _axis;


// WEBPACK FOOTER //
// ./layouts/bar/_axis.js